import {Inject, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {EnvironmentService} from "@services/environment-service/environment.service";
import {WINDOW} from "@constants/global-objects.constants";

@Injectable({
  providedIn: 'root'
})
export class TolstoyService {
  private initialized = false;
  private tolstoyVisible = false;
  private readonly scriptId = 'tolstoyWidgetElement';
  private readonly renderer: Renderer2;

  constructor(
      rendererFactory: RendererFactory2,
      @Inject(WINDOW) window: Window,
      @Inject(DOCUMENT) private readonly document: Document,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    window.tolstoyAppKey = EnvironmentService.environment.tolstoy.appKey;
  }

  initTolstoy(): void {
    this.tolstoyVisible = true;
    if (this.initialized) {
      return;
    }
    this.renderScript();
    this.initialized = true;
  }

  private renderScript() {
    const src = EnvironmentService.environment.tolstoy.scriptUrl;
    const script = this.renderer.createElement('script');
    this.renderer.setAttribute(script, 'type', 'text/javascript');
    this.renderer.setAttribute(script, 'src', src);
    this.renderer.setAttribute(script, 'id', this.scriptId);
    this.renderer.appendChild(this.document.head, script);
  }

  destroyTolstoy() {
    const script = document.getElementById(this.scriptId);
    if (script) {
      this.renderer.removeChild(this.document.head, script);
    }
  }

  showTolstoyVideo() {
    if (!this.tolstoyVisible) {
      this.toggleTolstoyVideoVisibilityInDocument(this.document, true);
    }
  }

  hideTolstoyVideo(): void {
    if (this.tolstoyVisible) {
      this.toggleTolstoyVideoVisibilityInDocument(this.document, false);
    }
  }

  private toggleTolstoyVideoVisibilityInDocument(document: Document, showTolstoy: boolean) {
    const video = document.getElementById(this.scriptId);
    if (video) {
      this.toggleVisibilityClass(video, showTolstoy);
      this.tolstoyVisible = showTolstoy;
    }
  }

  private toggleVisibilityClass(element: HTMLElement | Element, show: boolean) {
    show
        ? element.classList.remove('visually-hidden')
        : element.classList.add('visually-hidden');
  }
}
